import SessionService from "../server/session";
import systemSettings from "../server/systemSettings";

const publicPaths = [
  "SignIn",
  "Confirm",
  "Welcome",
  "AppointmentRequestAdd",
  "PatientRegistration"
];

// eslint-disable-next-line no-unused-vars
const LoginGuard = async (to, from, next) => {
  const settings = await systemSettings.get();
  const portalConfig = settings.data;
  const islogged = SessionService.isLogged();
  if (
    islogged &&
    publicPaths
      .filter(path => path !== "AppointmentRequestAdd")
      .includes(to.name)
  ) {
    return next("/home");
  } else if (!islogged && !publicPaths.includes(to.name)) {
    return next("/signin");
  }

  if (to.name === "Welcome") {
    if (
      portalConfig &&
      (!portalConfig.newPatientRegistrationEnabled &&
        (portalConfig.appointmentRequestEnable === false ||
          (!islogged &&
            portalConfig.appointmentRequestNewPatientEnable === false)))
    ) {
      next("/signin");
    }
  } else if (to.name === "AppointmentRequestAdd") {
    if (
      portalConfig &&
      (portalConfig.appointmentRequestEnable === false ||
        (!islogged &&
          portalConfig.appointmentRequestNewPatientEnable === false))
    ) {
      next("/signin");
    }
  } else if (to.name === "PatientRegistration") {
    if (
      portalConfig && portalConfig.newPatientRegistrationEnabled === false
    ) {
      next("/welcome");
    }
  }
  return next();
};

export default LoginGuard;
